"use strict";
module.exports = {
    main: 'line-height:1.3;color:#f5bb12;background:#1e1e1e;overflow:auto;',
    error: 'line-height:1.3;color:#f5bb12;background:#1e1e1e;overflow:auto;',
    key: 'color:#d3422e;',
    string: 'color:#7fd6fa;',
    value: 'color:#bfd7db;',
    boolean: 'color:#4bae16;',
};
